import { InputHTMLAttributes } from 'react'

export function getStepForInputType(
  inputType: InputHTMLAttributes<HTMLInputElement>['type'],
) {
  // A step of "any" will allow decimal values to be entered into number inputs. Otherwise, the
  // step defaults to 1 and only integer values are allowed.
  return inputType === 'number' ? 'any' : undefined
}
